import { StatusBadge } from '@/components/ui/StatusBadge';
import { Icon } from '@/components/ui/Icon';

export interface PhoneLookup {
  name?: string | null;
  label?: string | null;
  is_spam?: boolean;
  is_verified?: boolean;
  source?: string;
  confidence?: number;
}

export interface PhoneCellProps {
  // Contacts imported without a phone (or legacy rows) arrive as null —
  // the cell must render a dash, not crash the whole screen.
  number: string | null | undefined;
  lookup?: PhoneLookup | null;
  size?: 'sm' | 'md';
  lang?: 'he' | 'en';
}

export function PhoneCell({ number, lookup, size = 'md', lang = 'he' }: PhoneCellProps) {
  const formatted = number ? formatIsraeli(number) : '—';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span dir="ltr" style={{ fontSize: size === 'sm' ? 'var(--t-sm)' : 'var(--t-md)', fontWeight: 500 }}>
          {formatted}
        </span>
        {lookup?.is_verified && (
          <span title={lang === 'he' ? 'מאומת' : 'Verified'}>
            <Icon name="ok" size={14} color="var(--ok)" />
          </span>
        )}
        {lookup?.is_spam && (
          <StatusBadge tone="danger" size="sm">
            {lookup.label ?? (lang === 'he' ? 'ספאם' : 'Spam')}
          </StatusBadge>
        )}
      </div>
      {lookup?.name && (
        <span style={{ fontSize: 'var(--t-xs)', color: 'var(--text-2)' }}>{lookup.name}</span>
      )}
    </div>
  );
}

export function formatIsraeli(number: string | null | undefined): string {
  if (!number) return '—';
  const digits = String(number).replace(/\D/g, '');
  if (digits.startsWith('972')) {
    const local = '0' + digits.slice(3);
    if (local.length === 10) return `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6)}`;
    return local;
  }
  if (digits.length === 10) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 9) return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
  return number;
}
